/* Sharrow Find My Boat page. Brand list matches the homepage list in sharrow-home.js ("b" = boat brand, "e" = engine brand). */
(function(){
  function init(){
    const root=document.getElementById('sharrowFindMyBoat');
    if(!root||root.dataset.ready==='1') return;
    root.dataset.ready='1';

    const brands=[["ACI Boats","b"],["Air-Craft Boats","b"],["Albemarle Boats","b"],["Albury Brothers Boats","b"],["Allied Boats","b"],["Alumacraft","b"],["Alweld Boats","b"],["Andros Boatworks","b"],["Aquila Power Catamarans","b"],["ArrowCat","b"],["Avalon Pontoons","b"],["Axopar","b"],["Back Cove Yachts","b"],["Bahama Boatworks","b"],["Baja Marine","b"],["Barker Boatworks","b"],["Barletta Boats","b"],["Bay Welding Boats","b"],["Bayliner","b"],["Beneteau","b"],["Bennington","b"],["Bertram Yachts","b"],["Blackfin","b"],["Blue Wave Boats","b"],["Boston Whaler","b"],["BRABUS Marine","b"],["Buddy Davis","b"],["Calcutta Boats","b"],["Campion","b"],["Cape Horn","b"],["Carolina Skiff","b"],["Caymas Boats","b"],["Celebrity Boats","b"],["Chaparral Boats","b"],["Checkmate Powerboats","b"],["Cheetah Marine","b"],["Chris-Craft","b"],["Cigarette Racing","b"],["Cobalt Boats","b"],["Cobia Boats","b"],["Concept Boats","b"],["Contender Boats","b"],["Cox Marine","e"],["Crest Pontoons","b"],["Crestliner","b"],["Crownline","b"],["Cruisers Yachts","b"],["Cutwater Boats","b"],["Dargel Boats","b"],["Deep Impact Custom Boats","b"],["Donzi","b"],["Duckworth Boats","b"],["Dusky Marine","b"],["Eastern Boat Works","b"],["EdgeWater Power Boats","b"],["Everglades Boats","b"],["Evinrude","e"],["Finnmaster","b"],["Formula Boats","b"],["Fountain Powerboats","b"],["Four Winns","b"],["Freeman Boatworks","b"],["Galeon Yachts","b"],["Gause Built Custom Boats","b"],["Genesis Craft","b"],["Glacier Bay","b"],["Glastron","b"],["Godfrey Pontoons","b"],["Grady-White Boats","b"],["Grand Inflatable Boats","b"],["Hammer Yachts","b"],["Harris Pontoons","b"],["HCB Yachts","b"],["Hells Bay Boatworks","b"],["Hewes Craft","b"],["Honda Marine","e"],["Hurricane Boats","b"],["Hydra-Sports","b"],["Hysucat","b"],["Iguana Yachts","b"],["Insetta Boatworks","b"],["Intrepid Powerboats","b"],["Invictus Yacht","b"],["Invincible Boats","b"],["Jeanneau","b"],["Jupiter Marine","b"],["Key West Boats","b"],["KingFisher Boats","b"],["Larson Boats","b"],["LeisureCat","b"],["Life Proof Boats","b"],["Lund Boats","b"],["Majek Boats","b"],["MAKO Boats","b"],["Manitou Pontoons","b"],["Marauder Marine","b"],["Mares","b"],["MasterCraft","b"],["Mercury Marine","e"],["Metal Shark","b"],["Midnight Express","b"],["MJM Yachts","b"],["Monterey Boats","b"],["MTI","b"],["NauticStar Boats","b"],["Neptunus Yachts","b"],["Nimbus Boats","b"],["Nordkapp","b"],["North River Boats","b"],["Novurania","b"],["Ocean Alexander","b"],["OXE Marine","e"],["Paramount Powerboats","b"],["Parker Boats","b"],["Pathfinder Boats","b"],["PlayCraft Boats","b"],["Premier Pontoons","b"],["Princecraft","b"],["Pro-Line Boats","b"],["Pursuit Boats","b"],["Quicksilver Boats","b"],["Quintrex","b"],["Ranger Boats","b"],["Ranger Tugs","b"],["Reef Runner Boats","b"],["Regal Boats","b"],["Regulator Marine","b"],["RIBCRAFT","b"],["Rinker Boats","b"],["Robalo Boats","b"],["Rossborough Boats","b"],["SAFE Boats International","b"],["Sailfish Boats","b"],["Sanger Boats","b"],["Saxdor Yachts","b"],["Schaefer Yachts","b"],["Scout Boats","b"],["Sea Fox Boats","b"],["Sea Hunt Boats","b"],["Sea Ray","b"],["SeaHunter","b"],["SeaLegs","b"],["Seaswirl","b"],["SeaVee Boats","b"],["Silver Dolphin","b"],["Skagit Orca","b"],["Skeeter","b"],["Southport Boats","b"],["Sportsman Boats","b"],["Stabicraft","b"],["Stamas Yachts","b"],["Stanley Aluminum Boats","b"],["Starcraft Marine","b"],["Steiger Craft","b"],["Stingray Boats","b"],["SunCatcher Pontoons","b"],["Suzuki Marine","e"],["Tactical Custom Boats","b"],["Tahoe Boats","b"],["Targa","b"],["Thunder Jet","b"],["Tiara Yachts","b"],["Tidewater Boats","b"],["Titan Boats","b"],["Trophy Sportfishing Boats","b"],["Twin Vee PowerCats","b"],["Valhalla Boatworks","b"],["Vela Boatworks","b"],["Vexus Boats","b"],["Warrior Boats","b"],["Weldcraft","b"],["Wellcraft","b"],["World Cat","b"],["Xcursion Pontoons","b"],["Xpress Boats","b"],["Yamaha","e"],["Yellowfin","b"],["Zodiac Nautic","b"]];

    const normalize=s=>(s||'').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').replace(/[^a-z0-9]+/g,'');
    const entries=brands.map((b,i)=>({name:b[0],type:b[1],norm:normalize(b[0]),i}))
      .sort((a,b)=>a.name.localeCompare(b.name,'en',{sensitivity:'base'}));

    /* Stats */
    const boatCount=entries.filter(b=>b.type==='b').length;
    const engineCount=entries.filter(b=>b.type==='e').length;
    const boatStat=root.querySelector('[data-fmb-count="boat"]');
    const engineStat=root.querySelector('[data-fmb-count="engine"]');
    if(boatStat) boatStat.textContent=String(Math.floor(boatCount/10)*10)+'+';
    if(engineStat) engineStat.textContent=String(engineCount);

    /* Search card (same behavior as the homepage section) */
    const form=root.querySelector('.fmb-form');
    const input=root.querySelector('#fmb-input');
    const list=root.querySelector('#fmb-datalist');
    const card=root.querySelector('.fmb-search-card');
    const result=root.querySelector('.fmb-result');
    const icon=root.querySelector('.fmb-result-icon');
    const title=root.querySelector('.fmb-result-copy strong');
    const copy=root.querySelector('.fmb-result-copy p');
    const suggestions=root.querySelector('.fmb-suggestions');
    entries.forEach(b=>{const o=document.createElement('option');o.value=b.name;list.appendChild(o);});

    function storeBrand(b){
      try{sessionStorage.setItem('sharrowSelectedBrand',JSON.stringify({name:b.name,type:b.type==='e'?'engine':'boat'}));}catch(e){}
    }
    function showBrand(b){
      storeBrand(b);
      result.hidden=false;
      result.classList.remove('not-found');
      icon.textContent='✓';
      title.textContent=b.name+' is represented.';
      copy.textContent=b.type==='e' ? `SHARROW™ has been delivered for customer boats powered by ${b.name}.` : `SHARROW™ has been delivered for customer boats from ${b.name}.`;
      suggestions.replaceChildren();
    }
    function showMissing(q){
      result.hidden=false;
      result.classList.add('not-found');
      icon.textContent='?';
      title.textContent=q ? q+' is not listed yet.' : 'Enter a boat or engine brand.';
      copy.textContent=q ? 'That does not mean we cannot fit your boat. Open Prop Finder and tell us about your exact setup.' : 'Start typing to search the brands represented in the SHARROW™ community.';
      suggestions.replaceChildren();
    }
    function showChoices(matches){
      result.hidden=false;
      result.classList.remove('not-found');
      icon.textContent='…';
      title.textContent='Choose your brand.';
      copy.textContent='We found several close matches.';
      suggestions.replaceChildren();
      matches.slice(0,5).forEach(b=>{
        const button=document.createElement('button');
        button.type='button';button.className='fmb-suggestion';button.textContent=b.name;
        button.addEventListener('click',()=>{input.value=b.name;showBrand(b);});
        suggestions.appendChild(button);
      });
    }
    function searchBrand(){
      const raw=input.value.trim();
      const q=normalize(raw);
      if(!q){showMissing('');return;}
      const exact=entries.find(b=>b.norm===q || b.norm===q.replace(/marine$/,''));
      if(exact){showBrand(exact);return;}
      const matches=entries.filter(b=>b.norm.includes(q)||q.includes(b.norm));
      if(matches.length===1){showBrand(matches[0]);return;}
      if(matches.length>1){showChoices(matches);return;}
      showMissing(raw);
    }
    form.addEventListener('submit',e=>{e.preventDefault();searchBrand();});
    input.addEventListener('change',()=>{if(input.value.trim()) searchBrand();});

    /* Directory */
    const groupsEl=root.querySelector('.fmb-groups');
    const lettersEl=root.querySelector('.fmb-letters');
    const filter=root.querySelector('#fmb-filter');
    const empty=root.querySelector('.fmb-empty');
    const toggles=[...root.querySelectorAll('[data-fmb-type]')];
    const alphabet='ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
    let type='all';

    const keyOf=name=>{const c=name.charAt(0).toUpperCase();return /[A-Z]/.test(c)?c:'#';};
    const items=[];
    const groups={};
    entries.forEach(b=>{
      const k=keyOf(b.name);
      if(!groups[k]){
        const g=document.createElement('div');
        g.className='fmb-group';g.id='fmb-letter-'+k;
        const l=document.createElement('div');l.className='fmb-group-letter';l.textContent=k;l.setAttribute('aria-hidden','true');
        const ul=document.createElement('ul');ul.setAttribute('aria-label','Brands starting with '+k);
        g.append(l,ul);groupsEl.appendChild(g);
        groups[k]={el:g,ul:ul};
      }
      const li=document.createElement('li');
      const btn=document.createElement('button');
      btn.type='button';btn.className='fmb-brand';
      const nm=document.createElement('span');nm.textContent=b.name;
      btn.appendChild(nm);
      if(b.type==='e'){const t=document.createElement('span');t.className='fmb-tag';t.textContent='Engine';btn.appendChild(t);}
      btn.setAttribute('aria-label',b.name+(b.type==='e'?' (engine brand)':' (boat brand)')+'. Show result');
      btn.addEventListener('click',()=>{
        input.value=b.name;showBrand(b);
        card.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
      });
      li.appendChild(btn);groups[k].ul.appendChild(li);
      items.push({b,li,k});
    });

    function renderLetters(visible){
      lettersEl.replaceChildren();
      alphabet.forEach(k=>{
        if(visible.has(k)){
          const a=document.createElement('a');a.href='#fmb-letter-'+k;a.textContent=k;
          a.addEventListener('click',e=>{e.preventDefault();const t=root.querySelector('#fmb-letter-'+k);if(t)t.scrollIntoView({behavior:'smooth',block:'start'});});
          lettersEl.appendChild(a);
        }else{
          const s=document.createElement('span');s.textContent=k;s.setAttribute('aria-hidden','true');lettersEl.appendChild(s);
        }
      });
    }
    function applyFilter(){
      const q=normalize(filter.value);
      const visible=new Set();
      items.forEach(it=>{
        const show=(type==='all'||it.b.type===type)&&(!q||it.b.norm.includes(q));
        it.li.hidden=!show;
        if(show) visible.add(it.k);
      });
      Object.keys(groups).forEach(k=>{groups[k].el.hidden=!visible.has(k);});
      empty.hidden=visible.size>0;
      renderLetters(visible);
    }
    filter.addEventListener('input',applyFilter);
    toggles.forEach(btn=>btn.addEventListener('click',()=>{
      type=btn.dataset.fmbType;
      toggles.forEach(t=>t.setAttribute('aria-pressed',String(t===btn)));
      applyFilter();
    }));
    applyFilter();

    /* Deep link: /pages/find-my-boat?brand=Grady-White */
    try{
      const param=new URLSearchParams(window.location.search).get('brand');
      if(param){input.value=param;searchBrand();}
    }catch(e){}
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  document.addEventListener('shopify:section:load',e=>{if(e.target&&e.target.querySelector('#sharrowFindMyBoat')) init();});
})();
